import {
  getClientTimeZone,
  formatDateTime,
  formatTimeSpan,
  Dateable,
  TimeSpanFormatter,
  useDate,
} from "../..";

interface RelativeTimeProp {
  date: Dateable;
  formatter?: TimeSpanFormatter;
  hasSuffix?: boolean;
}

export const RelativeTime = (props: RelativeTimeProp) => {
  const { date, formatter = formatTimeSpan, hasSuffix } = props;
  // Get timezone from AppProvider (if exists)
  const { timezone } = useDate();

  // fallback to client timezone then to UTC if that fails
  const clientTimezone = timezone || getClientTimeZone() || "UTC";

  const formattedISODate = formatDateTime(date, "iso", clientTimezone);

  return (
    <time dateTime={formattedISODate} title={formattedISODate}>
      {formatter(Date.now(), date, hasSuffix !== false)}
    </time>
  );
};
